/**
 * License Criteria tab content for License Management page.
 *
 * Extracted from LicenseManagementPage.tsx (Sub-PR 6.3).
 */

import type { LicenseCriteria, Organisation, XeroInvoiceState } from '../../types'
import { CriteriaFilterBar } from './CriteriaFilterBar'
import { CriteriaImportSection } from './CriteriaImportSection'
import { CriteriaStatsSummary } from './CriteriaStatsSummary'
import { CriteriaTable } from './CriteriaTable'
import { useCriteriaTabState } from './use-criteria-tab-state'

interface CriteriaTabProps {
  criteria: LicenseCriteria[]
  organisations: Organisation[]
  xeroInvoices: XeroInvoiceState[]
  onRefresh: () => Promise<void>
}

export function CriteriaTab(props: CriteriaTabProps): React.ReactElement {
  const { criteria, organisations, xeroInvoices, onRefresh } = props
  const state = useCriteriaTabState({ criteria, organisations, onRefresh })
  return (
    <div className="space-y-6">
      <CriteriaImportSection
        controls={state.importControls}
        organisations={organisations}
        xeroInvoices={xeroInvoices}
      />
      <CriteriaFilterBar filters={state.filters} organisations={organisations} />
      <CriteriaTable
        criteria={state.filteredCriteria}
        getOrgName={state.getOrgName}
        verifyingId={state.actions.verifyingId}
        invalidatingId={state.actions.invalidatingId}
        onVerify={(id) => {
          void state.actions.handleVerify(id)
        }}
        onInvalidate={(id) => {
          void state.actions.handleInvalidate(id)
        }}
      />
      <CriteriaStatsSummary criteria={criteria} />
    </div>
  )
}
